import '../../assets/css/style.min.css'
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { g, getPercentage, log, t, timeFrom } from "../../../../utils/index"
import { collection, doc, getCountFromServer, getDoc, getDocs, getFirestore, orderBy, query, where } from "firebase/firestore"
import { percentageBar, pieChart, radialBar } from '../../assets/js/scripts';
import { firebaseConfig } from '../../components/config';
import { Dashboard } from '../../components/dashboard';
import { User } from '../../components/user';

const dashboardApp = "delivery"

const app = initializeApp(firebaseConfig);
const firestore = getFirestore()
const auth = getAuth();

const user = new User(app)

var loaderDiv = g("loader-wrapper");
loaderDiv.addEventListener("transitionend", function () {
  loaderDiv.style.display = "none";
}, true);

const removeSplash = () => {
  // Kick off the CSS transition
  loaderDiv.style.opacity = 0.0;
}

export async function getAccount(uid, callback, noAccountCallback) {
  const account = await getDoc(doc(firestore, `account/${uid}`))

  if (account.exists()) {
    callback(account.data())
  } else {
    noAccountCallback()
  }
}

const initUser = (user) => {
  console.log(user.uid);
  const photoURL = user.photoURL;
  // The user's ID, unique to the Firebase project. Do NOT use
  // this value to authenticate with your backend server, if
  // you have one. Use User.getToken() instead.

  if (photoURL != undefined) {
    g('profile_image').src = photoURL
  } else {
    g('profile_image').src = "https://firebasestorage.googleapis.com/v0/b/pickaapp-79307.appspot.com/o/Rectangle%201.png?alt=media&token=a63c9a1c-6e18-451c-9b3b-8c5e907d64be"
  }
}

async function initDashboard(uid, activeSubCallback, inactiveSubCallback) {
  getDoc(doc(firestore, `dashboard/${uid}`)).then((dashboardAppSubscription) => {
    if (dashboardAppSubscription.exists()) {
      const operatorData = dashboardAppSubscription.data()

      const appHandler = (mDashboardApp) => {
        if (mDashboardApp != undefined) {
          if (mDashboardApp.active) {
            const expires = mDashboardApp.expires.toDate()
            const now = new Date()

            if (now.getTime() < expires.getTime()) {
              activeSubCallback(mDashboardApp)
            } else { inactiveSubCallback() }
          } else { inactiveSubCallback() }
        } else { inactiveSubCallback() }
      }


      if (dashboardApp === "ride") {
        appHandler(operatorData)
      } else {
        appHandler(operatorData[dashboardApp])
      }
    } else {
      inactiveSubCallback()
    }
  }).catch((e) => {
    log(e.message)
  })
}

user.init(async (u) => {
  initDashboard(u.uid, async (operatorData) => {
    const appId = operatorData["appId"]

    initUser(u)

    var d = new Date();
    d.setHours(0, 0, 0, 0);

    // const ordersCol = collection(firestore, "deliveries")

    (async function () {
      const deliveriesCol = collection(firestore, "deliveries")

      const qTotalDeliveries = query(
        deliveriesCol,
        ...[where("timestamp", ">=", d), where("for", "==", operatorData["appId"])]
      )

      const qsTotalDeliveries = await getDocs(qTotalDeliveries)

      var total = 0
      var totalActual = 0

      qsTotalDeliveries.forEach((delivery) => {
        const dData = delivery.data()

        total += dData.estimatedFare

        if (dData.stage <= 6) {
          if (dData.stage >= 3) {
            totalActual += dData.estimatedFare
          }
        }
      })

      g("total_today_earning").innerText = `KWA${Math.round((10 / 100 * total + Number.EPSILON) * 100) / 100}`
      g("total_today").innerText = `KWA${Math.round((total + Number.EPSILON) * 100) / 100}`
      g("total_today_earning_a").innerText = `KWA${Math.round((10 / 100 * totalActual + Number.EPSILON) * 100) / 100}`
      g("total_today_a").innerText = `KWA${Math.round((totalActual + Number.EPSILON) * 100) / 100}`
    }());

    (async function () {
      const qRiders = query(collection(firestore, "rider"), ...[where("owner", "==", u.uid)])
      const qsRiders = await getDocs(qRiders)

      g("driver_count").innerText = qsRiders.size

      var newRiderCount = 0
      const riders = qsRiders.docs.map(rider => rider.data())

      for (let m = 0; m < riders.length; m++) {
        const rider = riders[m];

        var timestamp = rider.timestamp.toDate()
        console.log(timestamp);

        if (timestamp >= d) {
          console.log("gfdsa");
          newRiderCount += 1
        }
      }

      g("new_drivers_count").innerText = newRiderCount
    }());

    (async function () {
      const deliveriesCol = collection(firestore, "deliveries")

      const qTotalDeliveries = query(deliveriesCol, ...[
        where("app", "==", appId)
      ])
      getCountFromServer(qTotalDeliveries).then((result) => {
        const count = result.data().count
        g("rides_count").innerText = count
      })

      const qTotalCompletedDeliveries = query(deliveriesCol, ...[
        where("app", "==", appId),
        where("commissionPaid", "==", true)
      ])
      getCountFromServer(qTotalCompletedDeliveries).then((result) => {
        const count = result.data().count
        g("completed_rides_count").innerText = count
      })
    }());

    var monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    function getFirstDayOfMonth(year, month) {
      return new Date(year, month, 1);
    }
    function getLastDayOfMonth(year, month) {
      return new Date(year, month + 1, 0);
    }

    function getLast3Months(n) {
      var today = new Date();
      var last3Months = []

      for (let x = 0; x < n; x++) {
        var m = today.getMonth() - x
        last3Months.push(getFirstDayOfMonth(today.getFullYear(), m));
      }

      last3Months.reverse()

      return last3Months;
    }

    async function gL3mStats(startDates = []) {
      var labels = []

      var d1 = []
      var d2 = []

      for (let x = 0; x < startDates.length; x++) {
        const startDate = new Date(startDates[x]);
        log(startDate)

        const completedRidesThisMonthQuery = query(collection(firestore, "deliveries"), ...[
          where("timestamp", ">=", startDate),
          where("timestamp", "<=", getLastDayOfMonth(startDate.getFullYear(), startDate.getMonth())),
          where("commissionPaid", "==", true),
          where("app", "==", appId)
        ])

        const qs = await getDocs(completedRidesThisMonthQuery)

        var cTotal = 0

        for (let x = 0; x < qs.docs.length; x++) {
          const element = qs.docs[x];
          cTotal += element.data().estimatedFare
        }

        labels.push(monthNames[startDate.getMonth()])
        d1.push(cTotal)
        d2.push(getPercentage(15, cTotal))
      }

      return {
        labels: labels,
        d1: d1,
        d2: d2
      }
    }

    async function gCount(collectionName, queries) {
      const colQuery = query(collection(firestore, collectionName), ...queries)
      const colSnapshot = await getCountFromServer(colQuery)
      return colSnapshot.data().count
    }

    async function gCountsTotal(dates, collectionName) {
      var counts = []

      for (let index = 0; index < dates.length; index++) {
        const date = dates[index];

        const cloned = new Date(date.getTime())
        cloned.setHours(cloned.getHours() + 24)

        const n = await gCount(collectionName, [
          where("app", "==", appId),
          where("timestamp", ">", date),
          where("timestamp", "<", cloned)
        ])

        counts.push({ v: n, date: date })
      }

      counts.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.date) - new Date(a.date);
      })

      return counts.map(o => o.v).reverse()
    }

    async function gCountTotalCompleted(dates, collectionName) {
      var counts = []

      for (let index = 0; index < dates.length; index++) {
        const date = dates[index];

        const cloned = new Date(date.getTime())
        cloned.setHours(cloned.getHours() + 24)

        const n = await gCount(
          collectionName,
          [
            where("app", "==", appId),
            where("commissionPaid", "==", true),
            where("timestamp", ">", date),
            where("timestamp", "<", cloned)
          ]
        )

        counts.push({ v: n, date: date })
      }

      counts.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.date) - new Date(a.date);
      })

      return counts.map(o => o.v).reverse()
    }

    (function () {
      gL3mStats(getLast3Months(3)).then((l3mStats) => {
        var columnChart5 = g('monthly-column-chart');

        new Chart({
          element: columnChart5,
          type: 'column',
          stacked: true,
          xAxis: {
            line: true,
            labels: l3mStats.labels,
            ticks: true
          },
          yAxis: {
            labels: true
          },
          datasets: [
            // { data: [1, 2, 3, 12, 8, 7, 10, 4, 9, 5, 16, 3] },
            // { data: [4, 8, 10, 12, 15, 11, 7, 3, 5, 2, 12, 6] }

            { data: l3mStats.d1 },
            { data: l3mStats.d2 }
          ],
          column: {
            width: '60%',
            gap: '2px',
            radius: '4px'
          },
          tooltip: {
            enabled: true,
            customHTML: function (index, chartOptions) {
              var html = '<p class="margin-bottom-xxs">Total ZMW' + chartOptions.datasets[0].data[index] + '</p>';
              html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-primary margin-right-xxs"></span>' + chartOptions.datasets[0].data[index] + '</p>';
              html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-contrast-higher margin-right-xxs"></span>' + chartOptions.datasets[1].data[index] + '</p>';
              return html;
            },
            position: 'top'
          },
          animate: true
        });

      })
    }());

    (async function () {
      const columnDays = timeFrom(d, 5, 'day').reverse()
      const columnDates = timeFrom(d, 5, 'date').reverse()

      const countsTotal = await gCountsTotal(columnDates, "deliveries")
      const countsTotalCompleted = await gCountTotalCompleted(columnDates, "deliveries")

      var columnChart3 = document.getElementById('column-chart-3');
      if (columnChart3) {
        new Chart({
          element: columnChart3,
          type: 'column',
          xAxis: {
            line: true,
            labels: columnDays,
            ticks: true
          },
          yAxis: {
            labels: true
          },
          datasets: [
            { data: countsTotal },
            { data: countsTotalCompleted }
          ],
          column: {
            width: '60%',
            gap: '2px',
            radius: '4px'
          },
          tooltip: {
            enabled: true,
            customHTML: function (index, chartOptions) {
              var html = '<p class="margin-bottom-xxs">Total ' + chartOptions.datasets[0].data[index] + '</p>';
              html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-primary margin-right-xxs"></span>' + chartOptions.datasets[0].data[index] + '</p>';
              html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-contrast-higher margin-right-xxs"></span>' + chartOptions.datasets[1].data[index] + '</p>';
              return html;
            },
            position: 'top'
          },
          animate: true
        });
      };
    }());

    removeSplash()
  }, () => {
    location.replace('../../subscribe/delivery')
  })
}, () => {
  location.replace('../../account/login')
})

require("../../assets/js/scripts")